import { render, staticRenderFns } from "./MsgDefault.vue?vue&type=template&id=738d4ea4"
import script from "./MsgDefault.vue?vue&type=script&lang=js"
export * from "./MsgDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports